var render = function render(){var _vm=this,_c=_vm._self._c;return _c('container-panel-active',{staticClass:"slice-programme-thumb-large"},[(_vm.slice.entry)?_c('programme-entry-thumb',{attrs:{"entry":_vm.slice.entry[0],"reverse":_vm.slice.format === 'imageText'}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }